import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

import {
  EmployeeClassesSidepanelCertificatesDocument,
  EmployeeClassesSidepanelUploadCertificateDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { NewFileModal } from 'modules/trainings/components/Files/NewFileModal'
import type { FileSubmissionData } from 'modules/trainings/components/Files/NewFileModal/types'

export default function UploadCertificateModal() {
  const { id, employeeId, trainingMembershipId } = useParams<{
    id: string
    employeeId: string
    trainingMembershipId: string
  }>()
  const { access, company } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [uploadCertificate] = useMutation(EmployeeClassesSidepanelUploadCertificateDocument, {
    extractorFn: (data) => data.trainingsMutations.bulkCreateTrainingsTrainingMembershipFile,
    awaitRefetchQueries: true,
    refetchQueries: [EmployeeClassesSidepanelCertificatesDocument],
  })
  const navigateBack = () =>
    navigate(
      navigation.trainings.list.details_revamp.view.participants.employees.fullPath({
        id: Number(id),
        employeeId: Number(employeeId),
      })
    )

  return (
    <NewFileModal
      noTitleField
      description={i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.upload_certificate_modal.description'
      )}
      title={i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.upload_certificate_modal.title'
      )}
      fileTypes={['image', 'document']}
      onClose={navigateBack}
      onSubmit={async (data: FileSubmissionData) => {
        const variables = {
          authorId: access.id,
          companyId: company.id,
          trainingId: Number(id),
          trainingMembershipId: Number(trainingMembershipId),
          file: data.file,
        }
        const result = await uploadCertificate({ variables })
        const handled = handleResult(result, () => {
          app.setFlash({
            type: 'wrong',
            message: i18n.t('trainings.session_access_membership_table.upload_files_error'),
          })
        })
        if (handled.success) {
          navigateBack()
        }
      }}
      resourceType="Trainings::TrainingMembership"
      resourceId={id}
    />
  )
}
